<!--@if(loading){
  <div class="position-absolute w-100 h-100 d-flex flex-column align-items-center bg-white justify-content-center">
    <mat-spinner></mat-spinner>
  </div>
} @else{-->
<ng-container *ngIf="loading"> <!---; else content">-->
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>

<!--ng-template #content-->
  <mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
      <mat-card-title>Oferta</mat-card-title>
    </mat-card-header-->
    <mat-card-content>

      <form class="form-container" (ngSubmit)="onSubmitOffer(offerForm)" #offerForm="ngForm" >

        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Datos Generales</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div id="container" class="formControl">
        
              <div class="control">
                <mat-slide-toggle [(ngModel)]="isInTypeOffer" name="typeOffer" [disabled]="offer.id !== 0">
                  {{ isInTypeOffer? 'Oferta Interna':'Oferta Externa'}} 
                </mat-slide-toggle>
              </div>
              
              <div class="control">
                <mat-form-field class="imput-full-width">
                  <mat-label>Folio</mat-label>
                  <input type="text" matInput name="offer.folio" [(ngModel)]="offer.folio" [readonly]="true">
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="imput-full-width">
                  <mat-label>Estado Oferta</mat-label>
                  <input type="text" matInput name="offer.status.description" [(ngModel)]="offer.status!.description" [readonly]="true">
                </mat-form-field>
              </div>

              <div class="control">
                <mat-slide-toggle [(ngModel)]="offer.active"  name="offerActive" > <!-- [disabled]="true" class="readonly-toggle"-->
                  {{ offer.active? 'Oferta Activa':'Oferta Inactiva'}} 
                </mat-slide-toggle>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <br>
        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Datos Persona</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div id="container" class="formControl">
              @if(isInTypeOffer){
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Numero Empleado</mat-label>
                  <input matInput type="text" name="employeeNumber" [(ngModel)]="offer.employee!.employeeNumber" 
                    (blur)="onEmployeeNumberChange(offer.employee!.employeeNumber)" [disabled]="employeeNumberDisable">
                  <mat-error>{{ violations['offer.employee.employeeNumber'] }}</mat-error>
                </mat-form-field>
              </div>        
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Nombre</mat-label>
                  <input matInput type="text" name="offer.employee.person.name" [(ngModel)]="offer.employee!.person.name">
                  <mat-error>{{ violations['offer.employee.person.name'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Paterno</mat-label>
                  <input matInput type="text" name="offer.employee.person.paternalSurname" [(ngModel)]="offer.employee!.person.paternalSurname">
                  <mat-error>{{ violations['offer.employee.person.paternalSurname'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Materno</mat-label>
                  <input matInput type="text" name="offer.employee.person.maternalSurname" [(ngModel)]="offer.employee!.person.maternalSurname">
                  <mat-error>{{ violations['offer.employee.person.maternalSurname'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Telefono</mat-label>
                  <input matInput type="text" name="offer.employee.person.telephone" [(ngModel)]="offer.employee!.person.telephone">
                  <mat-error>{{ violations['offer.employee.person.telephone'] }}</mat-error>
                </mat-form-field>            
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Cel</mat-label>
                  <input matInput type="text" name="offer.employee.person.cellPhone" [(ngModel)]="offer.employee!.person.cellPhone">
                  <mat-error>{{ violations['offer.employee.person.cellPhone'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Correo</mat-label>
                  <input type="email" matInput placeholder="Ex. pat@example.com" name="offer.employee.person.email" [(ngModel)]="offer.employee!.person.email">
                  <mat-error>{{ violations['offer.employee.person.email'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Fecha Nacimiento</mat-label>
                  <input matInput [matDatepicker]="picker" name="offer.employee.person.dateOfBirth" 
                  [(ngModel)]="offer.employee!.person.dateOfBirth">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error>{{ violations['offer.employee.person.dateOfBirth']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Edad</mat-label>
                  <input type="text" matInput name="offer.employee.person.years" [(ngModel)]="offer.employee!.person.years" 
                  [readonly]="true">
                  <mat-error>{{ violations['offer.employee.person.email'] }}</mat-error>
                </mat-form-field>
              </div>

            } @else{
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Nombre</mat-label>
                  <input matInput type="text" name="offer.applicant.person.name" [(ngModel)]="offer.applicant!.person.name">
                  <mat-error>{{ violations['offer.applicant.person.name'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Paterno</mat-label>
                  <input matInput type="text" name="offer.applicant.person.paternalSurname" 
                  [(ngModel)]="offer.applicant!.person.paternalSurname">
                  <mat-error>{{ violations['offer.applicant.person.paternalSurname'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Apellido Materno</mat-label>
                  <input matInput type="text" name="offer.applicant.person.maternalSurname" 
                  [(ngModel)]="offer.applicant!.person.maternalSurname">
                  <mat-error>{{ violations['offer.applicant.person.maternalSurname'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Telefono</mat-label>
                  <input matInput type="text" name="offer.applicant.person.telephone" [(ngModel)]="offer.applicant!.person.telephone">
                  <mat-error>{{ violations['offer.applicant.person.telephone'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Cel</mat-label>
                  <input matInput type="text" name="offer.applicant.person.cellPhone" [(ngModel)]="offer.applicant!.person.cellPhone">
                  <mat-error>{{ violations['offer.applicant.person.cellPhone'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Correo</mat-label>
                  <input type="email" matInput placeholder="Ex. pat@example.com" name="offer.applicant.person.email" 
                  [(ngModel)]="offer.applicant!.person.email">
                  <mat-error>{{ violations['offer.applicant.person.email'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Fecha Nacimiento</mat-label>
                  <input matInput [matDatepicker]="picker2"  name="offer.applicant.person.dateOfBirth" [(ngModel)]="offer.applicant!.person.dateOfBirth">
                  <mat-datepicker-toggle matIconSuffix [for]="picker2"> </mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                  <mat-error>{{ violations['offer.applicant.person.dateOfBirth'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Edad</mat-label>
                  <input type="text" matInput name="offer.applicant.person.years" [(ngModel)]="offer.applicant!.person.years" 
                  [readonly]="true">
                </mat-form-field>
              </div>
              }

              
            </div> 
          </mat-card-content>
          <mat-card-footer class="general-wf-card-footer">
          </mat-card-footer>
        </mat-card>
        <br>
        <!--div class="container_"-->
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <mat-card class="general-wf-card" appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Empleo Actual</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div id="container" class="formControl">
                    @if(isInTypeOffer){
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Division</mat-label>
                        <mat-select [(ngModel)]="offer.employee!.division" [compareWith]="compareDivisions" name="offer.employee.division" 
                        [disabled]="inputsCurrentDisable">
                        @for (division of divisions; track division.id) {
                          <mat-option [value]="division">{{ division.description }}</mat-option>
                        }
                        </mat-select>
                        <mat-error>{{ violations['offer.employee.division'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Area</mat-label>
                        <mat-select [(ngModel)]="offer.employee!.area"  [compareWith]="compareAreas" name="offer.employee.area" 
                        [disabled]="inputsCurrentDisable">
                        @for (area of areas ; track area.id) {
                          <mat-option [value]="area">{{ area.description }}</mat-option>
                        }
                      </mat-select>
                      <mat-error>{{ violations['offer.employee.area'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Ubicacion Empleo</mat-label>
                        <input matInput type="text" name="offer.employee.workLocation" [(ngModel)]="offer.employee!.workLocation">
                        <mat-error>{{ violations['offer.employee.workLocation'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    @if(offer.employee!.employeeNumber != '0'){
                      <div class="control">
                        <mat-form-field class="controlWidth">
                          <mat-label>Puesto Num</mat-label>
                          <input matInput type="text" name="offer.employee.position.positionNum" [(ngModel)]="offer.employee!.position.positionNum" [disabled]="inputsCurrentDisable">
                          <mat-error>{{ violations['offer.employee.position.positionNum'] }}</mat-error>
                        </mat-form-field>
                      </div>
                      <div class="control">
                        <mat-form-field class="controlWidth">
                          <mat-label>Puesto Des</mat-label>
                          <input matInput type="text" name="offer.employee.position.description" [(ngModel)]="offer.employee!.position.description" [disabled]="inputsCurrentDisable">
                          <mat-error>{{ violations['offer.employee.position.description'] }}</mat-error>
                        </mat-form-field>
                      </div>
                    }@else{
                      <div class="control">
                        <mat-form-field class="controlWidth">
                          <mat-label>Puesto Texto</mat-label>
                          <input matInput type="text" name="offer.employee.positionText" [(ngModel)]="offer.employee!.positionText">
                          <mat-error>{{ violations['offer.employee.positionText'] }}</mat-error>
                        </mat-form-field>
                      </div>
                    }
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Sueldo</mat-label>
                        <input matInput type="text" name="offer.employee.baseSalary" [(ngModel)]="offer.employee!.baseSalary" [disabled]="inputsCurrentDisable"
                        [appNumberFormat]="2" #salaryEmployeeCtrl="ngModel">
                        <mat-error>{{ violations['offer.employee.baseSalary'] }}</mat-error>
                        <mat-error *ngIf="salaryEmployeeCtrl.errors?.['invalidNumberFormat']">
                          Número inválido (máx. 2 decimales, usa ',' para miles)
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }@else{
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Empresa</mat-label>
                        <input matInput type="text" name="offer.applicant.currentCompany" [(ngModel)]="offer.applicant!.currentCompany">
                        <mat-error>{{ violations['offer.applicant.currentCompany'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Ubicacion Empleo</mat-label>
                        <input matInput type="text" name="offer.applicant.workLocation" [(ngModel)]="offer.applicant!.workLocation">
                        <mat-error>{{ violations['offer.applicant.workLocation'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Puesto</mat-label>
                        <input matInput type="text" name="offer.applicant.position" [(ngModel)]="offer.applicant!.position">
                        <mat-error>{{ violations['offer.applicant.position'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Sueldo</mat-label>
                        <input matInput type="text" name="offer.applicant.baseSalary" [(ngModel)]="offer.applicant!.baseSalary" [appNumberFormat]="2" #salaryApplicantCtrl="ngModel">
                        <mat-error>{{ violations['offer.applicant.baseSalary'] }}</mat-error>
                        <mat-error *ngIf="salaryApplicantCtrl.errors?.['invalidNumberFormat']">
                          Número inválido (máx. 2 decimales, usa ',' para miles)
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  </div>
                </mat-card-content>
            <mat-card-footer class="general-wf-card-footer">
            </mat-card-footer>
              </mat-card>
            </div>
            <div class="col-12 col-md-6">
              <mat-card class="general-wf-card" appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Empleo Ofertado</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div id="container" class="formControl">
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Division</mat-label>
                        <mat-select [(ngModel)]="offer.division" [compareWith]="compareDivisions" name="offer.division">
                          @for (division of divisions; track division.id) {
                            <mat-option [value]="division">{{ division.description }}</mat-option>
                          }
                        </mat-select>
                        <mat-error>{{ violations['offer.division'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Area</mat-label>
                        <mat-select [(ngModel)]="offer.area"  [compareWith]="compareAreas" name="offer.area">
                          @for (area of areas ; track area.id) {
                            <mat-option [value]="area">{{ area.description }}</mat-option>
                          }
                        </mat-select>
                        <mat-error>{{ violations['offer.area'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Ubicacion Empleo</mat-label>
                        <input matInput type="text" name="offer.workLocation" [(ngModel)]="offer.workLocation">
                        <mat-error>{{ violations['offer.workLocation'] }}</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Sueldo</mat-label>
                        <input matInput type="text" name="offer.baseSalary" [(ngModel)]="offer.baseSalary" [appNumberFormat]="2" #salaryCtrl="ngModel">
                        <mat-error>{{ violations['offer.baseSalary'] }}</mat-error>
                        <mat-error *ngIf="salaryCtrl.errors?.['invalidNumberFormat']">
                          Número inválido (máx. 2 decimales, usa ',' para miles)
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Fecha Inicio Puesto</mat-label>
                        <input matInput [matDatepicker]="picker2"  name="offer.startDateEmployment" [(ngModel)]="offer.startDateEmployment">
                        <mat-datepicker-toggle matIconSuffix [for]="picker2"> </mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        <mat-error>{{ violations['offer.startDateEmployment'] }}</mat-error>
                      </mat-form-field>
                    </div>

                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Numero Puesto</mat-label>
                        <input matInput type="text" name="offer.position" [(ngModel)]="offer.position!.positionNum" 
                          (blur)="onPositionNumberChange(offer.position!.positionNum)" [disabled]="positionNumberDisable">
                        <mat-error>{{ violations['offer.position'] }}</mat-error>
                      </mat-form-field>
                    </div>

                    <div class="control">
                      <mat-form-field class="controlWidth">
                        <mat-label>Puesto Des</mat-label>
                        <input matInput type="text" name="offer.position.description" [(ngModel)]="offer.position!.description" disabled="true">
                      </mat-form-field>
                    </div>

                  </div>
                </mat-card-content>
                <mat-card-footer class="general-wf-card-footer">
                </mat-card-footer>
              </mat-card>
            </div>
          </div>
        <!--/div-->
        <br>
        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Beneficios</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            @if(!isInTypeOffer){
            <div class="control"> 
              <button mat-flat-button class="button buttonWidth" type="button" (click)="addBenefit()">
                Agregar Beneficio
              </button>
            </div>
            }
            <!--app-table #beneficiosTable [tableModel]="tableModel"></app-table-->

            <table mat-table [dataSource]="offer.offerBenefitList" class="mat-elevation-z8 table-benefits" multiTemplateDataRows>

              <!-- Columna B -->
              <!--ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>Id g</th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="row.editable; else labelB">
                    <input matInput [(ngModel)]="row.b" />
                  </ng-container>
                  <ng-template #labelB>
                    {{ row.id }}
                  </ng-template>
                </td>
              </ng-container-->

              <ng-container matColumnDef="benefit">
                <th mat-header-cell *matHeaderCellDef>Beneficio</th>
                <td mat-cell *matCellDef="let row; let i = index">
                  <ng-container *ngIf="isConfigPresent(row); else labelDesc">
                    <input matInput [(ngModel)]="row.benefitOut" [name]="'benefitOut' + row.rowIndex" />
                  </ng-container>
                  <ng-template #labelDesc>
                    {{ row.currentBenefitConfiguration? row.currentBenefitConfiguration.benefit.description : row.offeredBenefitConfiguration.benefit.description }}
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="typeB">
                <th mat-header-cell *matHeaderCellDef>Tipo</th>
                <td mat-cell *matCellDef="let row; let i = index">
                  <ng-container *ngIf="isConfigPresent(row); else labelDesc">
                    <mat-select [(ngModel)]="row.benefitTypeOut"  [compareWith]="compareBenefitTypes" [name]="'benefitTypeOut' + row.rowIndex">
                      @for (benefitType of benefitTypes ; track benefitType.id) {
                        <mat-option [value]="benefitType">{{ benefitType.description }}</mat-option>
                      }
                    </mat-select> 
                  </ng-container>
                  <ng-template #labelDesc>
                    {{ row.currentBenefitConfiguration? row.currentBenefitConfiguration.benefit.benefitType.description : row.offeredBenefitConfiguration.benefit.benefitType.description }}
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="descriptionC">
                <th mat-header-cell *matHeaderCellDef>Descripción</th>
                <td mat-cell *matCellDef="let row; let i = index">
                  <ng-container *ngIf="!isInTypeOffer; else labelDesc">
                    <input matInput [(ngModel)]="row.currentDescriptionOut" [name]="'currentDescriptionOut' + row.rowIndex" />
                  </ng-container>
                  <ng-template #labelDesc>
                    {{ row.currentBenefitConfiguration? row.currentBenefitConfiguration.description : '' }}
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="valueCalculateC">
                <th mat-header-cell *matHeaderCellDef>Valor Calculado Actual</th>
                <td mat-cell *matCellDef="let row; let i = index" class="right-align">
                  <ng-container *ngIf="!isInTypeOffer; else labelCV">
                    <input matInput [(ngModel)]="row.currentValueOut"  [name]="'currentValueOut' + row.rowIndex"/>
                  </ng-container>
                  <ng-template #labelCV>
                    {{ row.currentValue }}
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="descriptionO">
                <th mat-header-cell *matHeaderCellDef>Descripción</th>
                <td mat-cell *matCellDef="let row">
                  <!--ng-container *ngIf="row.editable; else labelB">
                    <input matInput [(ngModel)]="row.b" />
                  </ng-container-->
                  <!--ng-template #labelB-->
                    {{ row.offeredBenefitConfiguration? row.offeredBenefitConfiguration.description : '' }}
                  <!--/ng-template-->
                </td>
              </ng-container>

              <ng-container matColumnDef="valueCalculateO">
                <th mat-header-cell *matHeaderCellDef>Valor Calculado Ofertado</th>
                <td mat-cell *matCellDef="let row" class="right-align">
                  <!--ng-container *ngIf="row.editable; else labelB">
                    <input matInput [(ngModel)]="row.b" />
                  </ng-container-->
                  <!--ng-template #labelB-->
                    {{ row.offerredValue }}
                  <!--/ng-template-->
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columndefs"></tr>
              <tr mat-row *matRowDef="let row; columns: columndefs;"></tr>
    
            </table>

          </mat-card-content>
          <mat-card-footer class="general-wf-card-footer">
          </mat-card-footer>
        </mat-card>
        <br>

        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Retenciones</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- @if(!isInTypeOffer){
            <div class="control"> 
              <button mat-flat-button class="button buttonWidth" type="button" (click)="addBenefit()">
                Agregar Beneficio
              </button>
            </div>
            }-->
            <!--app-table #beneficiosTable [tableModel]="tableModel"></app-table-->

            <table mat-table [dataSource]="offer.offerWithholdingList" class="mat-elevation-z8 table-withholdings" multiTemplateDataRows>


              <ng-container matColumnDef="withholding">
                <th mat-header-cell *matHeaderCellDef>Retención</th>
                <td mat-cell *matCellDef="let row; let i = index">
                  <ng-container *ngIf="isConfigPresentWithholding(row); else labelDesc">
                    <input matInput [(ngModel)]="row.withholdingOut" [name]="'withholdingOut' + row.rowIndex" />
                  </ng-container>
                  <ng-template #labelDesc>
                    {{ row.currentWithholdingConfiguration? row.currentWithholdingConfiguration.withholding.description : row.offeredWithholdingConfiguration.withholding.description }}
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="typeB">
                <th mat-header-cell *matHeaderCellDef>Tipo</th>
                <td mat-cell *matCellDef="let row; let i = index">
                  <ng-container *ngIf="isConfigPresentWithholding(row); else labelDesc">
                    <mat-select [(ngModel)]="row.withholdingTypeOut"  [compareWith]="compareWithholdingTypes" [name]="'withholdingTypeOut' + row.rowIndex">
                      @for (withholdingType of withholdingTypes ; track withholdingType.id) {
                        <mat-option [value]="withholdingType">{{ withholdingType.description }}</mat-option>
                      }
                    </mat-select> 
                  </ng-container>
                  <ng-template #labelDesc>
                    {{ row.currentWithholdingConfiguration? row.currentWithholdingConfiguration.withholding.withholdingType.description : row.offeredWithholdingConfiguration.withholding.withholdingType.description }}
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="descriptionC">
                <th mat-header-cell *matHeaderCellDef>Descripción</th>
                <td mat-cell *matCellDef="let row; let i = index">
                  <ng-container *ngIf="!isInTypeOffer; else labelDesc">
                    <input matInput [(ngModel)]="row.currentDescriptionOut" [name]="'currentDescriptionOut' + row.rowIndex" />
                  </ng-container>
                  <ng-template #labelDesc>
                    {{ row.currentWithholdingConfiguration? row.currentWithholdingConfiguration.description : '' }}
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="valueCalculateC">
                <th mat-header-cell *matHeaderCellDef>Valor Calculado Actual</th>
                <td mat-cell *matCellDef="let row; let i = index" class="right-align">
                  <ng-container *ngIf="!isInTypeOffer; else labelCV">
                    <input matInput [(ngModel)]="row.currentValueOut"  [name]="'currentValueOut' + row.rowIndex"/>
                  </ng-container>
                  <ng-template #labelCV>
                    {{ row.currentValue }}
                  </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="descriptionO">
                <th mat-header-cell *matHeaderCellDef>Descripción</th>
                <td mat-cell *matCellDef="let row">
                  <!--ng-container *ngIf="row.editable; else labelB">
                    <input matInput [(ngModel)]="row.b" />
                  </ng-container-->
                  <!--ng-template #labelB-->
                    {{ row.offeredWithholdingConfiguration? row.offeredWithholdingConfiguration.description : '' }}
                  <!--/ng-template-->
                </td>
              </ng-container>

              <ng-container matColumnDef="valueCalculateO">
                <th mat-header-cell *matHeaderCellDef>Valor Calculado Ofertado</th>
                <td mat-cell *matCellDef="let row" class="right-align">
                  <!--ng-container *ngIf="row.editable; else labelB">
                    <input matInput [(ngModel)]="row.b" />
                  </ng-container-->
                  <!--ng-template #labelB-->
                    {{ row.offerredValue }}
                  <!--/ng-template-->
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columndefsW"></tr>
              <tr mat-row *matRowDef="let row; columns: columndefsW;"></tr>
    
            </table>

          </mat-card-content>
          <mat-card-footer class="general-wf-card-footer">
          </mat-card-footer>
        </mat-card>
        <br>
        <!--mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Detalle Beneficios</mat-card-title>
          </mat-card-header>
          <mat-card-content-->
            <!--div id="container" class="formControl">
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Beneficios Garantizados - PG</mat-label>
                  <input type="text" matInput name="offer.guaranteedBenefits" [(ngModel)]="offer.guaranteedBenefits" [readonly]="true">
                  <mat-error>{{ violations['offer.guaranteedBenefits'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Beneficios Periodicos - BP</mat-label>
                  <input type="text" matInput name="offer.periodicBenefits" [(ngModel)]="offer.periodicBenefits" [readonly]="true">
                  <mat-error>{{ violations['offer.periodicBenefits'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Beneficios Pago Unico - BPU</mat-label>
                  <input type="text" matInput name="offer.singlePaymentBenefits" [(ngModel)]="offer.singlePaymentBenefits" [readonly]="true">
                  <mat-error>{{ violations['offer.singlePaymentBenefits'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Otros Beneficios - OB</mat-label>
                  <input type="text" matInput name="offer.otherBenefits" [(ngModel)]="offer.otherBenefits" [readonly]="true">
                  <mat-error>{{ violations['offer.otherBenefits'] }}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Diferencia Sueldo</mat-label>
                  <input type="text" matInput name="offer.salaryDifference" [(ngModel)]="offer.salaryDifference" [readonly]="true">
                  <mat-error>{{ violations['offer.salaryDifference'] }}</mat-error>
                </mat-form-field>
              </div>
            </div-->
          <!--/mat-card-content>
          <mat-card-footer class="general-wf-card-footer">
          </mat-card-footer>
        </mat-card>
        <br-->
        <mat-card class="general-wf-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Firmas</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- Mostrar firmas a seleccionar solo cuando es nueva -->
            @if(offer.status!.code === 'NUEVA') {
              @for (signature of offer.offerSignatures; track signature.id ?? signature; let i = $index) {
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Firma {{ signature.number }}</mat-label>
                  <mat-select [(ngModel)]="signature.user"
                    [compareWith]="compareUsers"
                    name="userSignature_{{signature.number}}">
                    @for (user of signature.usersSignaturesOptions; track user.id) {
                      <mat-option [value]="user">
                        {{ user.person.name }} {{ user.person.paternalSurname }} {{ user.person.maternalSurname }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            } @else{
              <table class="table-auto border-collapse border border-gray-400 w-full table-signatures">
                <thead>
                  <tr>
                    <!--th class="border border-gray-400 p-2">Firma</th-->
                    <th *ngFor="let signature of offer.offerSignatures" class="border border-gray-400 p-2">
                      Firma {{ signature.number }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <!--th class="border border-gray-400 p-2">Firmante</th-->
                    <td *ngFor="let signature of offer.offerSignatures" class="border border-gray-400 p-2">
                      {{ signature.user!.person.fullName }}
                    </td>
                  </tr>
                  <tr>
                    <!--td class="border border-gray-400 p-2">Estatus</td-->
                    <td *ngFor="let signature of offer.offerSignatures" class="border border-gray-400 p-2">
                      <div class="flex items-center gap-2">
                      
                      <ng-container [ngSwitch]="signature.status.code">
                        <mat-icon *ngSwitchCase="'SOL'" class="iconSignature iconSignatureSol">access_time</mat-icon>
                        <mat-icon *ngSwitchCase="'AUT'" class="iconSignature iconSignatureAut">check_circle</mat-icon>
                        <mat-icon *ngSwitchCase="'RECH'" class="iconSignature iconSignatureRech">cancel</mat-icon>
                        <mat-icon *ngSwitchCase="'REC'" class="iconSignature iconSignatureRec">how_to_reg</mat-icon>
                        <mat-icon *ngSwitchDefault class="iconSignature iconSignatureDefault">help_outline</mat-icon>
                      </ng-container>

                      <span class="whitespace-nowrap">
                        {{ signature.status.description }}
                      </span>

                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td *ngFor="let signature of offer.offerSignatures"class="border border-gray-400 p-2">

                      {{ signature.observations }}

                  </td>
                  </tr>
                </tbody>
              </table>
              
            }
        </mat-card-content>
        <mat-card-footer class="general-wf-card-footer">
        </mat-card-footer>
      </mat-card>
      <br>
      <mat-card class="general-wf-card" appearance="outlined">
        <mat-card-header>
          <mat-card-title>Adicionales</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div id="container" class="formControl">
            <div class="control">
              <mat-form-field class="controlWidth">
                <mat-label>Comentarios</mat-label>
                <textarea matInput placeholder="Comentarios" name="offer.observations" [(ngModel)]="offer.observations"></textarea>
                <mat-error>{{ violations['offer.observations'] }}</mat-error>
              </mat-form-field>
            </div>
            <div class="control">
              <mat-form-field class="controlWidth">
                <mat-label>Justificación</mat-label>
                <textarea matInput placeholder="Justificación" name="offer.justification" [(ngModel)]="offer.justification"></textarea>
                <mat-error>{{ violations['offer.justification'] }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
        <mat-card-footer class="general-wf-card-footer">
        </mat-card-footer>
      </mat-card>
      <br>
      <div class="formControl">
        @if(offer.status!.code === 'NUEVA' || offer.id == 0) {
          <div class="control">
            <button mat-flat-button class="button buttonWidth">
              {{(offer.id > 0)? 'Actualizar': 'Guardar'}}
              <mat-icon>save</mat-icon>
            </button>
          </div>
        }
        @if(offer.id > 0){
          @if(offer.status!.code === 'NUEVA') {
            <div class="control">
              <button mat-flat-button class="button buttonWidth" type="button" (click)="recalculateOffer()">
                {{'Recalcular'}}
                <mat-icon>calculate</mat-icon>
              </button>
            </div>
          }
          <div class="control">
            <button mat-flat-button class="button buttonWidth buttonColorTwo" type="button" (click)="printOffer()">
              {{'Imprimir'}}
              <mat-icon>print</mat-icon>
            </button>
          </div>
          @if(offer.status!.code === 'NUEVA') {
            <div class="control">
              <button mat-flat-button class="button buttonWidth buttonColorOne" type="button" (click)="getSignatures()">
                {{'Mostrar Firmas'}}
                <mat-icon>person_check</mat-icon>
              </button>
            </div>
            <div class="control">
              <button mat-flat-button class="button buttonWidth buttonColorOne" type="button" (click)="sendSignatures()">
                {{'Avanzar con Firmas'}}
                <mat-icon>play_arrow</mat-icon>
              </button>
            </div>
          }
          @if(offer.status!.code === 'AUTORIZADA') {
            <div class="control">
              <button mat-flat-button class="button buttonWidth buttonColorTwo" type="button" (click)="applyOffer()">
                {{'Aplicar oferta'}}
                <mat-icon>check_circle</mat-icon>
              </button>
            </div>
          }
          <div class="control">
            <button mat-flat-button class="button buttonWidth buttonColorThree" type="button" (click)="deleteOffer()">
              {{'Eliminar oferta'}}
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
      </div>
      </form>
  
    </mat-card-content>
<mat-card-footer class="general-wf-card-footer">
</mat-card-footer>
</mat-card>
<br>
<!--/ng-template-->